export default {"src":"/_next/static/media/url.2256e06f.svg","height":40,"width":40};